import { format } from 'date-fns';
import UserActionsDropdown from './UserActionsDropdown.jsx';

export default function UserTable({ users, currentPage, itemsPerPage, handleSort, sortField, sortOrder, onSuspend, onDelete }) {
    return (
        <>
            <table className="table">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th onClick={() => handleSort('userRole.name')} style={{ cursor: 'pointer', textDecoration: "underline" }}>Rol{' '}
                            {sortField === 'userRole.name' && (
                                sortOrder === 'asc'
                                    ? <i className="bi bi-caret-up-fill"></i>
                                    : <i className="bi bi-caret-down-fill"></i>
                            )}
                        </th>
                        <th onClick={() => handleSort('userCompany.name')} style={{ cursor: 'pointer', textDecoration: "underline" }}>Empresa{' '}
                            {sortField === 'userCompany.name' && (
                                sortOrder === 'asc'
                                    ? <i className="bi bi-caret-up-fill"></i>
                                    : <i className="bi bi-caret-down-fill"></i>
                            )}
                        </th>
                        <th onClick={() => handleSort('name')} style={{ cursor: 'pointer', textDecoration: "underline" }}>Nombre{' '}
                            {sortField === 'name' && (
                                sortOrder === 'asc'
                                    ? <i className="bi bi-caret-up-fill"></i>
                                    : <i className="bi bi-caret-down-fill"></i>
                            )}
                        </th>
                        <th onClick={() => handleSort('lastname')} style={{ cursor: 'pointer', textDecoration: "underline" }}>Apellidos{' '}
                            {sortField === 'lastname' && (
                                sortOrder === 'asc'
                                    ? <i className="bi bi-caret-up-fill"></i>
                                    : <i className="bi bi-caret-down-fill"></i>
                            )}
                        </th>
                        <th scope="col">Usuario</th>
                        <th scope="col">Email</th>
                        <th scope="col">Fecha de creación</th>                           
                        <th scope="col">Estatus</th>
                        <th scope="col">Comentarios</th>
                        <th scope="col">Acciones</th>
                    </tr>
                </thead>
                <tbody className="table-group-divider">
                    {users?.length === 0 ? (
                        <tr>
                            <td colSpan="11" className="text-center">
                                No hay registros disponibles
                            </td>
                        </tr>
                    ) : (
                        users.map((user, index) => {
                            const rowNumber = (currentPage - 1) * itemsPerPage + index + 1;
                            return (
                                <tr key={user.id}>
                                    <td>{rowNumber}</td>
                                    <td>{user.userRole?.name || 'N/A'}</td>
                                    <td>{user.userCompany?.name || 'N/A'}</td>
                                    <td>{user.name}</td>
                                    <td>{user.lastname}</td>
                                    <td>{user.username}</td>
                                    <td>{user.email}</td>
                                    <td>{format(new Date(user.createdAt), 'dd-MM-yyyy')}</td>
                                    <td>
                                        {user.suspended ? (
                                            <>
                                                <span className="badge" style={{color: '#1d2125',backgroundColor: '#ced4da'}}>Suspendido</span>
                                            </>
                                        ) : (
                                            <>Activo</>
                                        )}
                                    </td>
                                    <td>{user.description}</td>
                                    <td>
                                        <UserActionsDropdown
                                            user={user}
                                            onSuspend={onSuspend}
                                            onDelete={onDelete}
                                        />
                                    </td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </table>
        </>
    );
}